










import { defineComponent } from "@vue/composition-api";
import { VaultCategory } from "@scrile/api-provider/dist/api/VaultsProvider";
import BaseIcon from "@/components/Base/BaseIcon";
import VaultFiles from "../VaultFiles";

export default defineComponent({
  name: "VaultCategoryItem",
  components: { BaseIcon, VaultFiles },
  props: {
    category: { type: Object as () => VaultCategory, required: true },
  },
});
